import { HeavyTicketDto } from '..'
import { HeavyTickets } from '@/Domain/Expediente'

export class HeavyTicketsDto {
    private _tickets: HeavyTicketDto[]
    private _total: number

    static fromHeavyTickets (heavy: HeavyTickets): HeavyTicketsDto {
      const tickets:HeavyTicketDto[] = []
      heavy.tickets.forEach(item => {
        tickets.push(HeavyTicketDto.fromHeavyTicket(item))
      })
      return new HeavyTicketsDto(
        tickets,
        heavy.total
      )
    }

    constructor (
      tickets: HeavyTicketDto[],
      total: number
    ) {
      this._tickets = tickets
      this._total = total
    }

    get tickets (): HeavyTicketDto[] {
      return this._tickets
    }

    get total (): number {
      return this._total
    }

    addTicket (ticket: HeavyTicketDto): void {
      this._tickets.push(ticket)
    }
}
